class WishlistProduct extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onAddWishlist);
    this.LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
    this.LOCAL_STORAGE_DELIMITER = ',';
    this.BUTTON_ACTIVE_CLASS = 'active';
    this.onAddActiveClass();
    this.WishlistItemCounter();
  }

  WishlistItemCounter() {
    let WISHLIST_ITEM_COUNT = document.querySelectorAll('.wishlist__count');
    let wishlist_item_length = this.getWishlist().length;

    if (WISHLIST_ITEM_COUNT) {
      console.log('[Wishlist] Wishlist item count updated: ', wishlist_item_length);
      WISHLIST_ITEM_COUNT.forEach((singleItem) => {
        if (wishlist_item_length <= 0) {
          singleItem.classList.add('hidden');
          singleItem.innerText = '';
        } else {
          singleItem.innerText = wishlist_item_length;
          singleItem.classList.remove('hidden');
        }
      });
    }
  }

  onAddActiveClass() {
    const wishlistAddedButton = this.querySelector('button');
    if (wishlistAddedButton != null) {
      let productHandle = wishlistAddedButton.dataset.productHandle || false;
      if (!productHandle)
        return console.error('[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
      if (this.wishlistContains(productHandle)) wishlistAddedButton.classList.add(this.BUTTON_ACTIVE_CLASS);
    }
  }

  onAddWishlist(evt) {
    evt.stopPropagation();

    const wishlistItem = this.querySelector('button');
    let productHandle = wishlistItem.dataset.productHandle || false;
    if (!productHandle)
      return console.error('[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');

    this.updateWishlist(productHandle);
    wishlistItem.classList.toggle(this.BUTTON_ACTIVE_CLASS);

    let wishlist_item_length = this.getWishlist().length;

    let grid = document.querySelector('[grid-wishlist]') || false;
    let wishlistPageWrapper = document.querySelector('.wishlist-page');
    let loader = wishlistPageWrapper?.querySelector('.loading__spinner');

    if (grid) {
      loader?.classList.remove('hidden');
      wishlistPageWrapper?.classList.add('loading');
      // Rerender the grid after updating wishlist
      setupGrid(grid).then(() => {
        loader?.classList.add('hidden');
        wishlistPageWrapper?.classList.remove('loading');
      });
    } else {
      wishlistItem.classList.add('loading', 'adding');
      setTimeout(function () {
        wishlistItem.classList.remove('loading');
      }, 500);

      setTimeout(function () {
        document.querySelector('.adding').classList.remove('adding');
      }, 1000);
    }

    if (wishlist_item_length <= 0 && wishlistPageWrapper) {
      grid?.parentElement.classList.remove('wishlist-exists');
    }

    this.WishlistItemCounter();
  }

  getWishlist() {
    let wishlist = localStorage.getItem(this.LOCAL_STORAGE_WISHLIST_KEY) || false;
    if (wishlist) return wishlist.split(this.LOCAL_STORAGE_DELIMITER);
    return [];
  }

  setWishlist(array) {
    let wishlist = array.join(this.LOCAL_STORAGE_DELIMITER);
    if (array.length) localStorage.setItem(this.LOCAL_STORAGE_WISHLIST_KEY, wishlist);
    else localStorage.removeItem(this.LOCAL_STORAGE_WISHLIST_KEY);
    return wishlist;
  }

  updateWishlist(handle) {
    let wishlist = this.getWishlist();
    let indexInWishlist = wishlist.indexOf(handle);
    if (indexInWishlist === -1) wishlist.push(handle);
    else wishlist.splice(indexInWishlist, 1);
    return this.setWishlist(wishlist);
  }

  wishlistContains(handle) {
    let wishlist = this.getWishlist();
    return wishlist.indexOf(handle) !== -1;
  }
}
customElements.define('wishlist-item', WishlistProduct);

let newWishlistObj = new WishlistProduct();

document.addEventListener('DOMContentLoaded', function () {
  let grid = document.querySelector('[grid-wishlist]');
  let wishlistPageWrapper = document.querySelector('.wishlist-page');
  let loader = wishlistPageWrapper?.querySelector('.loading__spinner');

  if (grid) {
    loader?.classList.remove('hidden');
    wishlistPageWrapper?.classList.add('loading');
    setupGrid(grid).then(() => {
      loader?.classList.add('hidden');
      wishlistPageWrapper?.classList.remove('loading');
    });
  }
});

var setupGrid = function (grid) {
  return new Promise((resolve) => {
    var wishlist = newWishlistObj.getWishlist();
    var wishlistSectionEl = document.querySelector('.wishlist-section');
    var wishlistPageWrapper = document.querySelector('.wishlist-page');
    const loader = wishlistPageWrapper?.querySelector('.loading__spinner');
    let emptylist = document.querySelector('.wishlist-grid--empty-list');

    // Show loader while loading
    loader?.classList.remove('hidden');

    if (wishlist.length > 0) {
      wishlistSectionEl?.classList.add('wishlist-has-items');
      wishlistPageWrapper?.classList.add('wishlist-exists');
      emptylist?.classList.add('hidden');
    } else {
      wishlistSectionEl?.classList.remove('wishlist-has-items');
      wishlistPageWrapper?.classList.remove('wishlist-exists');
      emptylist?.classList.remove('hidden');
    }

    var requests = wishlist.map(function (handle) {
      var productTileTemplateUrl = '/products/' + handle + '?view=wishlist';
      return fetch(productTileTemplateUrl).then(function (res) {
        if (res.status == 200) {
          return res.text();
        }
        return '';
      });
    });

    Promise.all(requests).then(function (responses) {
      var wishlistProductCards = responses.join('');
      grid.innerHTML = wishlistProductCards;

      loader?.classList.add('hidden');
      resolve();
    });
  });
};
